import { BOARD_INLAY_OFFSET, BOARD_INLAY_SIZE, BOARD_OUTER_OFFSET, BOARD_OUTER_SIZE, SQUARE_SIZE } from '../utils/constants.js';
import { BOARD_SIZE, fileOf, rowOf, squareAt } from '../game/squares.js';
import type { Square } from '../game/types.js';

/** 0 = White at the bottom, 180 = Black at the bottom. */
export type ViewerRotation = 0 | 180;

export interface Rect {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
}

export interface Point {
  readonly x: number;
  readonly y: number;
}

/** Screen column/row (0 = left/top) of a square for the viewer. */
function screenCell(sq: Square, rotation: ViewerRotation): { col: number; row: number } {
  if (rotation === 0) return { col: fileOf(sq), row: rowOf(sq) };
  return { col: BOARD_SIZE - 1 - fileOf(sq), row: BOARD_SIZE - 1 - rowOf(sq) };
}

export function squareToCanvasRect(sq: Square, rotation: ViewerRotation): Rect {
  const { col, row } = screenCell(sq, rotation);
  return { x: BOARD_INLAY_OFFSET + col * SQUARE_SIZE, y: BOARD_INLAY_OFFSET + row * SQUARE_SIZE, w: SQUARE_SIZE, h: SQUARE_SIZE };
}

export function squareToCanvasCenter(sq: Square, rotation: ViewerRotation): Point {
  const r = squareToCanvasRect(sq, rotation);
  return { x: r.x + SQUARE_SIZE / 2, y: r.y + SQUARE_SIZE / 2 };
}

/** The square under a canvas point, or null outside the inlay. */
export function canvasToSquare(x: number, y: number, rotation: ViewerRotation): Square | null {
  const dx = x - BOARD_INLAY_OFFSET;
  const dy = y - BOARD_INLAY_OFFSET;
  if (dx < 0 || dy < 0 || dx >= BOARD_INLAY_SIZE || dy >= BOARD_INLAY_SIZE) return null;
  const col = Math.floor(dx / SQUARE_SIZE);
  const row = Math.floor(dy / SQUARE_SIZE);
  return rotation === 0 ? squareAt(col, row) : squareAt(BOARD_SIZE - 1 - col, BOARD_SIZE - 1 - row);
}

export function getBoardOuterRect(): Rect {
  return { x: BOARD_OUTER_OFFSET, y: BOARD_OUTER_OFFSET, w: BOARD_OUTER_SIZE, h: BOARD_OUTER_SIZE };
}

/** Light squares are those where file + row is even (a8 and h1 are light). */
export function isLightSquare(sq: Square): boolean {
  return (fileOf(sq) + rowOf(sq)) % 2 === 0;
}
